import React from 'react';
import { useTheme } from '../context/ThemeContext';

const AppFooter = ({ noBorder = false }) => {
  const { theme } = useTheme();

  return (
    <footer className={`mt-auto w-full ${noBorder ? '' : 'border-t border-border'}`}>
      <div className={`${noBorder ? 'w-full px-4 md:px-6 lg:px-8' : 'container mx-auto max-w-7xl px-4 md:px-6'} py-5 flex items-center justify-between`}>
        <div className={`hidden md:block flex-1 ${noBorder ? 'lg:hidden' : ''}`} />
        <p className="flex items-center gap-1.5 text-xs text-muted-foreground">
          Developed & Maintained by Aiolos
        </p>
        <div className={`flex justify-end ${noBorder ? 'md:flex-1 lg:flex-none' : 'flex-1'}`}>
          <img
            src={theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches) ? '/aiolos-logo-white.svg' : '/aiolos-logo-blue.svg'}
            alt="Aiolos"
            className="h-6 opacity-80 hover:opacity-100 transition-opacity"
          />
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
